import config from '../../../lib/config';

export default function getSkadnetworkPostbackName(url) {
  const option = config.get('applications.skAdNetworkPostbackDestinationOptions')
    .find((o) => o.url === url);
  return option?.name;
}
